export { default as ToggleSwitch } from './toggle-switch';
export type { ToggleSwitchProps } from './types';
